import styled from 'styled-components'
import { DolaThemes } from '../../styles/types'
import { fontSize } from '../../styles/variables'

const theme = {
  dark: {
    background: 'rgba(16, 16, 16, .9)',
  },
  light: {
    background: 'rgba(255,255,255, .9)',
  },
}

export const Wrapper = styled.div`
  position: relative;
`

interface LoadingOverlayProps {
  dolaTheme: DolaThemes
}

export const LoadingOverlay = styled.div<LoadingOverlayProps>`
  align-items: center;
  background: ${({ dolaTheme }) => theme[dolaTheme].background};
  cursor: progress;
  display: flex;
  height: 100%;
  justify-content: center;
  position: absolute;
  top: 0%;
  width: 100%;
  z-index: 1;

  h1 {
    ${fontSize}
  }
`
